import React, { useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import classNames from 'classnames';

// Import configs and util modules
import { intlShape, injectIntl, FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';

// Import shared components
import { Button, Form } from '../../../../components';
import arrayMutators from 'final-form-arrays';
// Import modules from this directory
import css from './EditListingEnchanedServicesPanel.module.css';
import TalentPlusServices from '../EditListingMoreInfoPanel/TalentPlusServices/TalentPlusServices';
import AutoSave from './AutoSave';

export const EditListingEnchanedServicesFormComponent = props => {
  return (
    <FinalForm
      keepDirtyOnReinitialize
      {...props}
      mutators={{ ...arrayMutators }}
      render={formRenderProps => {
        const {
          className,
          disabled,
          ready,
          handleSubmit,
          invalid,
          pristine,
          saveActionMsg,
          updated,
          updateInProgress,
          fetchErrors,
          values,
          form,
          dirty,
          onLiveSubmit,
          onManageDisableScrolling,
          viewport,
        } = formRenderProps;

        const classes = classNames(css.root, className);
        const submitReady = (updated && pristine) || ready;
        const submitInProgress = updateInProgress;
        const submitDisabled = invalid || disabled || submitInProgress;
        const { updateListingError } = fetchErrors || {};
        const [isPlanModalOpen, setPlanModalOpen] = useState(false);

        // Modified to accept the current values from AutoSave
        const handleLiveSave = async currentValues => {
          try {
            await onLiveSubmit(currentValues, form);
          } catch (error) {
            console.error('Autosave failed', error);
          }
        };

        return (
          <Form onSubmit={handleSubmit} className={classes}>
            <FormSpy subscription={{ values: true }}>
              {({ values }) => <AutoSave values={values} onSave={handleLiveSave} />}
            </FormSpy>

            <TalentPlusServices
              viewport={viewport}
              values={values}
              hideTitle
              onLiveSave={handleLiveSave}
              onManageDisableScrolling={onManageDisableScrolling}
            />

            {updateListingError ? (
              <p className={css.error}>
                <FormattedMessage id="EditListingEnchanedServicesForm.updateFailed" />
              </p>
            ) : null}

            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>
          </Form>
        );
      }}
    />
  );
};

EditListingEnchanedServicesFormComponent.defaultProps = {
  fetchErrors: null,
  formId: 'EditListingEnchanedServicesForm',
};

EditListingEnchanedServicesFormComponent.propTypes = {
  formId: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  onLiveSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  updateInProgress: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingEnchanedServicesFormComponent);
